// composables/useTiptapPreview.ts
import { type JSONContent } from '@tiptap/vue-3'

export function useWysiwygPlainText() {
  /**
   * Recursively extracts text from Tiptap JSONContent.
   * Adds a space between block nodes for readability.
   */
  const extractTextFromJSON = (doc: JSONContent): string => {
    if (!doc) return ''

    // If the node is text, return it
    if (doc.type === 'text' && typeof doc.text === 'string') {
      return doc.text
    }

    // If the node has content, recursively map and join
    if (doc.content && Array.isArray(doc.content)) {
      return doc.content.map((child) => extractTextFromJSON(child)).join(' ')
    }

    return ''
  }

  /**
   * Generates a truncated preview string.
   */
  const getPreview = (doc: JSONContent, maxLength: number = 100): string => {
    const fullText = extractTextFromJSON(doc)

    if (fullText.length <= maxLength) return fullText

    return fullText.slice(0, maxLength).trim() + '...'
  }

  const hasTextContent = (doc?: JSONContent) => {
    if (!doc) return false
    return extractTextFromJSON(doc).trim().length > 0
  }

  return {
    getPreview,
    hasTextContent,
  }
}
